// src/Components/Email/EmailSidebar.js
import React, { useEffect } from 'react';
import '../../css/Emails.css';

import { useDispatch, useSelector } from 'react-redux';
import { fetchFolders, setMailbox,  clearSelectedEmail, startCompose } from '../../slices/emailSlice';
import Button from  '@mui/material/Button'
import SendIcon from '@mui/icons-material/Send';  // Send
import InboxIcon from '@mui/icons-material/Inbox';  // Inbox
import InventoryIcon from '@mui/icons-material/Inventory';// Archive
import EditNoteIcon from '@mui/icons-material/EditNote'; // Draft
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'; // Deleted
import UnsubscribeIcon from '@mui/icons-material/Unsubscribe'; // Junk
const EmailSidebar = () => {
  const dispatch = useDispatch();
  const {folders, selected, replyMode} = useSelector((state) =>state.emails);
  //const selected = useSelector((state) => state.emails.mailbox);

  const displayFolderIcon = (fldr) => {
    let folder = fldr;
    folder = folder.replaceAll("INBOX.", "")
    folder = folder.replaceAll("INBOX","Inbox")
    folder = folder.replaceAll("Trash","Deleted Items")
    folder = folder.replaceAll("spam","Spam")
    folder = folder.replaceAll("Junk","Junk Email")
    switch(folder.toLowerCase()) {
      case 'junk email':
        return
      case 'deleted Iitems':
        return <div className='folderitem'><DeleteOutlineIcon className='foldericon'  />&nbsp;{folder}</div>
      case 'archive':
        return <div className='folderitem'><InventoryIcon className='foldericon'  />&nbsp;{folder}</div>
      case 'spam':
        return <div className='folderitem'><DeleteOutlineIcon className='foldericon'  />Junk Emails</div>
      case 'drafts':
        return <div className='folderitem'><EditNoteIcon className='foldericon'  />&nbsp;{folder}</div>
      case 'sent':
        return <div className='folderitem'><SendIcon className='foldericon'  />&nbsp;{folder}</div>
      default:
        return <div className='folderitem'><InboxIcon className='foldericon'  />&nbsp;{folder}</div>

    }
  }
  useEffect(() => {
    dispatch(fetchFolders());
  }, [dispatch]);

  const handleFolderClick = (folder) => {
    dispatch(clearSelectedEmail())
    dispatch(setMailbox(folder));
    //dispatch(fetchEmails({ mailbox: folder }));
  };

  return (
    <div className="email-sidebar">
      {(!replyMode || replyMode!== 'compose') && <div className='newbtn'><Button onClick={() => dispatch(startCompose(true))} >New Email</Button></div> }
      <h4>Folders</h4>
      <ul style={{listStyle: 'none'}}>
        {folders && folders.map((folder) => {

          return (
          <li
            key={folder}
            onClick={() => handleFolderClick(folder)}
            style={{
              fontWeight: folder === selected ? 'bold' : 'normal',
              cursor: 'pointer',
              marginBottom: '6px'
            }}
          >
            {displayFolderIcon(folder)}
          </li>
        )})}
      </ul>
    </div>
  );
};

export default EmailSidebar;
